module.exports = __webpack_public_path__ + "static/media/survey_ad_image.124fbb53.png";